import axios, { AxiosRequestConfig } from 'axios';
import config from '../../config';
import { addAccessToken, tryRefreshToken } from './interceptors';

const axiosConfig: AxiosRequestConfig = {
  baseURL: config.apiUrl || '',
};

export const axiosInstance = axios.create(axiosConfig);

axiosInstance.interceptors.request.use(
  addAccessToken,
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  tryRefreshToken,
);
